import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DashboardHeader from "@components/Header/DashboardHeader";
import GenericBreadCrums from "@components/Breadcrumbs";
import bgImage from "../../assets/images/BG.svg";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export const PaymentSucces: React.FC = () => {
  const breadcrumbData = [{ label: "Application Details", link: "#" }];
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get("id");

  React.useEffect(() => {
    if (!id) {
      navigate("/application-dashboard");
    }
  }, []);

  return (
    <Box
      className="login-root"
      sx={{
        background: `url(${bgImage}) no-repeat top center`,
        backgroundSize: "cover",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div className="page-content">
        {/* <DashboardHeader /> */}
        <GenericBreadCrums breadcrumbs={breadcrumbData} className="mt-6" />
        <Box
          sx={{
            mt: 4,
            mx: 3,
            backgroundColor: "#FFFFFF",
            borderRadius: "12px",
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "70vh" // keeps it vertically centered
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              p: { xs: 3, md: 6 }
            }}
          >
            {/* Green Checkmark */}
            <CheckCircleIcon
              sx={{
                color: "#4CAF50",
                width: 90,
                height: 90,
                transform: "rotate(0deg)",
                opacity: 1,
                mb: 3
              }}
            />

            {/* Success Message */}
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: "18px",
                color: "#000000",
                mb: 4
              }}
            >
              Your payment has been completed successfully.
              <br />
              Your application number is{" "}
              <Typography
                component="span"
                sx={{
                  fontWeight: 700,
                  fontSize: "18px",
                  color: "#000000"
                }}
              >
                {id}
              </Typography>
            </Typography>

            {/* Go Back Button */}
            <Button
              variant="contained"
              onClick={() => navigate("/application-dashboard")}
              sx={{
                backgroundColor: "#4B0082",
                color: "#fff",
                textTransform: "none",
                borderRadius: "24px",
                px: 4,
                py: 1.2,
                fontWeight: 500,
                fontSize: "14px",
                "&:hover": {
                  backgroundColor: "#360061"
                }
              }}
            >
              Go Back to Dashboard
            </Button>
          </Box>
        </Box>
      </div>
    </Box>
  );
};

export default PaymentSucces;
